import { IAIImageState, IGenerateFormState } from 'store/types/aiImage'
import { AI_GENERATE_TAB_KEY } from 'containers/SubSidebar/AiImageContent/consts'

export const getInitialGenerateFormState = (): IGenerateFormState => {
  return {
    modelCode: '',
    prompt: '',
    styleId: undefined,
    refImages: {},
    aiImagePath: undefined, //if ai image is generated
    id: 0,
    images: [],
    width: 0,
    height: 0,
    targetMediaItemId: null
  }
}

export const getInitialState = (): IAIImageState => ({
  isRequestingGeneration: false,
  isRefImagesUploading: false,
  activeTab: AI_GENERATE_TAB_KEY,
  models: {
    data: null,
    isLoading: false
  },
  styles: {
    data: null,
    isLoading: false
  },
  restylingStyles: {
    data: null,
    isLoading: false
  },
  history: {
    data: null,
    totalCount: null,
    isLoading: false,
    isScopedToCurrentProject: true
  },
  deleteItemIds: null,
  generateForm: getInitialGenerateFormState(),
  versionHistory: {
    items: [],
    isLoading: false,
    isLoaded: false
  },
  showVersionHistoryTab: false
})
